import UbiServicesApi from "../api/UbiServicesApi";

export default class IpLocationService {
    static getIpLocation = () => {
        return UbiServicesApi.get(
            `/v2/profiles/me/iplocation`,
            {
                headers: {
                    'Ubi-AppId': process.env.REACT_APP_APP_ID
                }
            }
        );
    };
}